/**
 * Utility to fetch user profile photo from Microsoft Graph API
 */

export async function fetchMicrosoftPhoto(instance, account) {
  if (!instance) return null;

  const targetAccount =
    account ||
    (instance.getActiveAccount ? instance.getActiveAccount() : null) ||
    (instance.getAllAccounts ? instance.getAllAccounts()[0] : null);

  if (!targetAccount) return null;

  try {
    const tokenResponse = await instance.acquireTokenSilent({
      scopes: ["User.Read"],
      account: targetAccount,
    });

    if (!tokenResponse?.accessToken) return null;

    const response = await fetch(
      "https://graph.microsoft.com/v1.0/me/photo/$value",
      {
        headers: {
          Authorization: `Bearer ${tokenResponse.accessToken}`,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(blob);
      });
    }
  } catch (err) {
    // 404 is normal if the user hasn't uploaded a photo to Microsoft 365
    console.debug("Microsoft profile photo not found or could not be fetched:", err);
  }

  return null;
}
